var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<lb-nav></lb-nav>\n<div class=\"sctAdminWrapper\">\n<div class=\"sctAdmin\">\n<div class=\"sctAdmin_aside\">\n<sct-admin-nav ng-if=\"vm.userPermission.userLevel !== 'Traveller'\"></sct-admin-nav>\n</div>\n<div class=\"sctAdmin_main\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>\n<sct-footer></sct-footer>";
var id1="sct/sctAdmin/sctAdmin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctAdmin/sctAdmin.html
// module id = 1252
// module chunks = 1